import axios from "axios";


const bdaxios = axios.create({
    baseURL: process.env.REACT_APP_BASEURL,
});


export class Datos {

    async getTotalsData() {
        const res = await bdaxios.get('/totals');
        return res.data;
    }

    async getTotalsVotes(id, token) {

        try {     
            const res = await bdaxios({
                method: 'GET',
                url: '/votes/results/' + id,
                headers: {
                    Authorization: 'Bearer ' + token.value,
                },
            });
            return res.data
        } catch (error) {
            throw error
        }

    }



}